import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApiService } from '../../../../../core/services/api.service';
import { CityParkingUserLineResponse, CityParkingUserInfomationResponse, CityParkingUserProfilePayload, cityParkingVehicleMasterListResponse, CityParkingVehicleListResponse, CityParkingUserVehicleListResponse, CityParkingUserVehicleDeletePayload } from '../../../../../core/models/lineOA.model';
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { ToastService } from 'angular-toastify';
import { ModalLineOaMemberAddVehicleComponent } from "../modal-line-oa-member-add-vehicle/modal-line-oa-member-add-vehicle.component";
import { ModalAdminActivityHistoryComponent } from '../../system-settings/modal-admin-activity-history/modal-admin-activity-history.component';
import { AdminActivityEntityTypes } from '../../../../../core/models/system-settings/admin-activity-log.model';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import { CookieService } from 'ngx-cookie-service';
import { ActionBackOfficeResponse } from '../../../../../core/models/api.model';

@Component({
  selector: 'app-modal-line-oa-member',
  imports: [
    CommonModule,
    FormsModule,
    ModalLineOaMemberAddVehicleComponent,
    ModalAdminActivityHistoryComponent,
  ],
  templateUrl: './modal-line-oa-member.component.html',
  styleUrl: './modal-line-oa-member.component.css'
})
export class ModalLineOaMemberComponent {
  activeTab: 'info' | 'license' | 'card' = 'info';
  readonly activityEntityTypes = AdminActivityEntityTypes;
  showActivityHistory = false;

  // Payload
  memberPayload: CityParkingUserProfilePayload = {
    id: 0,
    name: '',
    fullName: '',
    phone: '',
    email: '',
    userStautsId: 0,
    language: '',
    alertEntry: false,
    alertExit: false,
    alertExpire: false,
    userId: 0
  }
  deleteVehiclePayload: CityParkingUserVehicleDeletePayload = {
    id: 0,
    plateNumber: '',
    cpUserId: 0,
    userId: 0
  }
  userId: number = 0

  // State สำหรับ Inline Editing
  editingField: string | null = null; // เก็บชื่อฟิลด์ที่กำลังแก้ ('fullName' หรือ 'phone')
  tempEditValue: string = '';         // เก็บค่าชั่วคราวขณะพิมพ์
  validationError: string | null = null;

  // Modal 
  isCloseModal: boolean = false // ใช้สำหรับเปิดปิด Modal
  eventForm: string = 'create'
  selectedMember: CityParkingUserLineResponse | null = null;
  memberProfile: CityParkingUserInfomationResponse | null = null;
  selectedLicense: CityParkingUserVehicleListResponse | null = null

  isAddVehicleModalOpen: boolean = false;
  // ตัวแปรสำหรับควบคุม Modal
  isDeleteModalOpen = false;
  itemToDelete: CityParkingUserVehicleListResponse | null = null; // เก็บ Object ของแถวที่กดลบ

  /** LINE profile picture preview */
  isPictureBroken = false;
  isPicturePreviewOpen = false;

  // Search State
  searchVehicleText: string = '';

  @Input() member: CityParkingUserLineResponse | null = null

  @Output() close = new EventEmitter<boolean>();

  constructor(
    private apiService: ApiService,
    private toast: ToastService,
    private toastCustom: ToastCustomService,
    private cookieService: CookieService
  ) { }

  ngOnInit(): void {
    const userIdFromSession = sessionStorage.getItem('user_id');
    this.userId = parseInt(this.cookieService.get('user_id')) || (userIdFromSession ? JSON.parse(userIdFromSession) : 0);

    if (this.member && this.userId) {
      this.selectedMember = this.member;
      this.isCloseModal = false
      this.getApiCityParkingUserProfile()
    }
  }
  /* ---------------------------------------- Function ---------------------------------------- */


  /* ------------------------- Get | Set ------------------------- */
  get pictureUrl(): string {
    const fromProfile = this.memberProfile?.cityParkingUserProfileResponse?.pictureUrl?.trim();
    if (fromProfile) return fromProfile;
    return this.selectedMember?.pictureUrl?.trim()
      || this.member?.pictureUrl?.trim()
      || '';
  }

  onPictureError(): void {
    this.isPictureBroken = true;
    this.isPicturePreviewOpen = false;
  }

  openPicturePreview(): void {
    if (!this.pictureUrl || this.isPictureBroken) return;
    this.isPicturePreviewOpen = true;
  }

  closePicturePreview(): void {
    this.isPicturePreviewOpen = false;
  }

  // Get filtered vehicles based on search text
  get filteredVehicles() {
    const vehicles = this.memberProfile?.cityParkingUserVehicleListResponses || [];
    if (!this.searchVehicleText) {
      return vehicles;
    }
    const searchText = this.searchVehicleText.toLowerCase();
    return vehicles.filter(v => 
      v.plateNumber?.toLowerCase().includes(searchText) || 
      v.provinceName?.toLowerCase().includes(searchText)
    );
  }

  resetProfile() {
    this.memberProfile = null
    this.editingField = null; // เก็บชื่อฟิลด์ที่กำลังแก้ ('fullName' หรือ 'phone')
    this.tempEditValue = '';         // เก็บค่าชั่วคราวขณะพิมพ์
    this.validationError = null;
    this.memberPayload = {
      id: 0,
      name: '',
      fullName: '',
      phone: '',
      email: '',
      userStautsId: 0,
      language: '',
      alertEntry: false,
      alertExit: false,
      alertExpire: false,
      userId: 0
    }
  }


  // --- Modal Functions (เดิม) ---
  openAddVehicleModal() {
    this.isAddVehicleModalOpen = true;
    this.isCloseModal = true
  }
  closeAddVehicleModal() {
    this.isAddVehicleModalOpen = false;
    this.isCloseModal = false
    this.getApiCityParkingUserProfile()
  }
  closeModal() {
    this.resetProfile();
    this.close.emit(true);
  }


  switchTab(tab: any) {
    this.activeTab = tab;
  }

  onCreateItem() {
    this.eventForm = 'create'
    this.openAddVehicleModal();
  }
  onEditItem(license: CityParkingUserVehicleListResponse) {
    if (!license.canEdit) {
      this.toast.error('รถคันนี้ไม่อนุญาตให้แก้ไข');
      return;
    }
    this.selectedLicense = license;
    this.eventForm = 'edit'
    this.openAddVehicleModal();
    //console.log('Edit', this.selectedLicense, license);
  }

  onDeleteItem(plate: CityParkingUserVehicleListResponse) {
    if (!plate.canEdit) {
      this.toast.error('รถคันนี้ไม่อนุญาตให้ลบ');
      return;
    }
    this.itemToDelete = plate; // จำไว้ว่ากำลังจะลบตัวไหน
    this.isDeleteModalOpen = true; // เปิด Modal
  }

  // 2. ฟังก์ชันปิด Modal (ยกเลิก)
  closeDeleteModal() {
    this.isDeleteModalOpen = false;
    this.itemToDelete = null; // เคลียร์ค่าทิ้ง
  }

  // 3. ฟังก์ชันยืนยันการลบ (กดปุ่มสีแดงใน Modal)
  confirmDelete() {
    if (this.itemToDelete) {
      if (!this.itemToDelete.canEdit) {
        this.toast.error('รถคันนี้ไม่อนุญาตให้ลบ');
        this.closeDeleteModal();
        return;
      }
      // *** ใส่ Code เรียก API ลบจริงๆ ตรงนี้ ***
      //console.log('Deleting:', this.itemToDelete.plateNumber);

      this.deleteVehiclePayload.id = this.itemToDelete.id;
      this.deleteVehiclePayload.plateNumber = this.itemToDelete.plateNumber;
      this.deleteVehiclePayload.cpUserId = this.itemToDelete.id;
      this.deleteVehiclePayload.userId = this.userId;

      this.sentApiDeleteVehicle();

      // เมื่อเสร็จแล้วให้ปิด Modal
      this.closeDeleteModal();
    }
  }
  // 1. เริ่มแก้ไข (กดปุ่มดินสอ)
  onStartEdit(field: string, currentValue: any) {
    this.editingField = field;
    this.tempEditValue = currentValue ? currentValue.toString() : '';
    this.validationError = null; // เคลียร์ error เก่า
  }

  // 2. ยกเลิก (กดปุ่ม X)
  onCancelEdit() {
    this.editingField = null;
    this.tempEditValue = '';
    this.validationError = null;
  }

  // 3. บันทึก (กดปุ่ม ✔)
  onSaveEdit(field: string) {
    // 3.1 Validate ข้อมูลตามประเภท Field
    if (!this.validateInput(field, this.tempEditValue)) {
      return; // ถ้าไม่ผ่าน หยุดทำงาน
    }

    // 3.2 สร้าง Payload ที่สมบูรณ์ (ต้องเอาค่าเดิมของ field อื่นมารวมด้วย)
    const currentProfile = this.memberProfile?.cityParkingUserProfileResponse;
    if (!currentProfile) return;

    this.memberPayload = {
      id: currentProfile.id,
      name: currentProfile.name, // ค่าเดิม
      fullName: field === 'fullName' ? this.tempEditValue : currentProfile.fullName, // ค่าใหม่ถ้าแก้ field นี้
      phone: field === 'phone' ? this.tempEditValue : currentProfile.phone, // ค่าใหม่ถ้าแก้ field นี้
      email: field === 'email' ? this.tempEditValue : currentProfile.email, // ค่าใหม่ถ้าแก้ field นี้
      userStautsId: currentProfile.userStautsId,
      language: currentProfile.language || 'th',
      alertEntry: currentProfile.alertEntry,
      alertExit: currentProfile.alertExit,
      alertExpire: currentProfile.alertExpire,
      userId: this.userId
    };

    //console.log(`Saving ${field}... Payload:`, this.memberPayload);

    // 3.3 ส่ง API (Mock)
    // this.apiService.updateProfile(payload).subscribe(...)

    // update หน้าจอให้เห็นผลทันที (หรือรอ subscribe เสร็จค่อยทำ)
    if (field === 'fullName') this.memberProfile!.cityParkingUserProfileResponse.fullName = this.tempEditValue;
    if (field === 'phone') this.memberProfile!.cityParkingUserProfileResponse.phone = this.tempEditValue;
    if (field === 'email') this.memberProfile!.cityParkingUserProfileResponse.email = this.tempEditValue;


    // ปิดโหมดแก้ไข
    this.onCancelEdit();
  }

  // ฟังก์ชันตรวจสอบความถูกต้อง
  validateInput(field: string, value: string): boolean {
    this.validationError = null;
    const val = value.trim();

    // Check ชื่อ
    if (field === 'fullName') {
      if (!val) {
        this.validationError = 'กรุณากรอกชื่อ-นามสกุล';
        return false;
      }
      if (val.length < 2) {
        this.validationError = 'ชื่อสั้นเกินไป';
        return false;
      }
    }

    // Check เบอร์โทร
    if (field === 'phone') {
      const phonePattern = /^[0-9]{10}$/; // ตัวเลข 10 หลักเท่านั้น
      if (!val) {
        this.validationError = 'กรุณากรอกเบอร์โทรศัพท์';
        return false;
      }
      if (!phonePattern.test(val)) {
        this.validationError = 'เบอร์โทรศัพท์ต้องเป็นตัวเลข 10 หลัก';
        return false;
      }
    }

    // --- Check: อีเมล (NEW) ---
    if (field === 'email') {
      // ถ้าอนุญาตให้เป็นค่าว่างได้ ให้ลบเงื่อนไข !val ออก
      if (val) {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        if (!emailPattern.test(val)) {
          this.validationError = 'รูปแบบอีเมลไม่ถูกต้อง';
          return false;
        }
      }
    }

    return true;
  }

  /**
   * Toggles the user status (2 = Active, 1 = Inactive) and uses sentApiCityparkingUserProfile to save
   * สลับสถานะผู้ใช้งานและอัปเดตผ่าน API
   * @param event The change event from the toggle switch
   */
  toggleUserStatus(event: any) {
    const currentProfile = this.memberProfile?.cityParkingUserProfileResponse;
    if (!currentProfile) return;

    const isChecked = event.target.checked;
    const newStatus = isChecked ? 2 : 1;

    // Prepare payload with the new status
    this.memberPayload = {
      id: currentProfile.id,
      name: currentProfile.name,
      fullName: currentProfile.fullName,
      phone: currentProfile.phone,
      email: currentProfile.email,
      userStautsId: newStatus,
      language: currentProfile.language || 'th',
      alertEntry: currentProfile.alertEntry,
      alertExit: currentProfile.alertExit,
      alertExpire: currentProfile.alertExpire,
      userId: this.userId
    };

    // Update local state to reflect UI change immediately
    currentProfile.userStautsId = newStatus;

    // Call the requested API method
    this.sentApiCityparkingUserProfile();
  }

  saveModal() {
    this.sentApiCityparkingUserProfile();
  }
  /* ---------------------------------------- API ---------------------------------------- */
  getApiCityParkingUserProfile() {
    this.apiService.getCityParkingUserProfile(this.member?.id || 0, this.member?.uid || '').subscribe({
      next: (response: CityParkingUserInfomationResponse) => {
        //console.log('CityParkingUserInfomationResponse', response);
        if (response) {
          this.isPictureBroken = false;
          this.memberProfile = response;
        }
        else {
          this.toast.error('ไม่พบข้อมูล');
        }
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }

  sentApiCityparkingUserProfile() {
    this.apiService.updateCityParkingUserProfile(this.memberPayload).subscribe({
      next: (response: ActionBackOfficeResponse) => {
        //console.log('updateCityParkingUserProfile : ', response);
        if (response.isSuccess) {
          this.toast.success(response.message);
          this.resetProfile();
          this.getApiCityParkingUserProfile();
        }
        else {
          this.toast.error(response.message);
        }
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }

  sentApiDeleteVehicle() {
    this.apiService.deleteCityparkingUserVehicle(this.deleteVehiclePayload).subscribe({
      next: (response: ActionBackOfficeResponse) => {
        //console.log('deleteVehicle : ', response);
        if (response.isSuccess) {
          this.toast.success(response.message);
          this.resetProfile();
          this.getApiCityParkingUserProfile();
        }
        else {
          this.toast.error(response.message);
        }
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }

  get canShowActivityHistory(): boolean {
    const id = this.memberProfile?.cityParkingUserProfileResponse?.id
      ?? this.memberPayload?.id
      ?? this.member?.id
      ?? 0;
    return id > 0;
  }

  openActivityHistory(): void {
    if (!this.canShowActivityHistory) return;
    this.showActivityHistory = true;
  }

  closeActivityHistory(): void {
    this.showActivityHistory = false;
  }

  get activityHistoryEntityId(): number {
    return this.memberProfile?.cityParkingUserProfileResponse?.id
      ?? this.memberPayload?.id
      ?? this.member?.id
      ?? 0;
  }

}
